import { IonIcon } from "@ionic/react";
import { ButtonHTMLAttributes, PropsWithChildren } from "react";
import styled from "styled-components";

export interface ButtonProps
  extends PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> {
  icon?: string;
  isIconBefore?: boolean;
}

const Button = ({ icon, isIconBefore, children, ...props }: ButtonProps) => {
  return (
    <StyledButton {...props}>
      {isIconBefore && icon && <StyledIcon src={icon} isIconBefore={isIconBefore}/>}
      {children}
      {!isIconBefore && icon && <StyledIcon src={icon} isIconBefore={isIconBefore}/>}
    </StyledButton>
  );
};

interface StyledIconProps {
  isIconBefore?: boolean;
}

const StyledIcon = styled(IonIcon)<StyledIconProps>`
  font-weight: bold;
  font-size: ${(props) => props.theme.icon.size.regular};
  color: inherit;
  margin: 5px;
  position: absolute;
  top: 50%;
  bottom: 50%;
  margin-top: auto;
  margin-bottom: auto;
  font-size: ${(props) => props.theme.icon.size.large};
  ${(props) => (props.isIconBefore ? 'left: 10px;' : 'right: 10px;')}
`;

const StyledButton = styled.button`
  /* CTAs ride the SECONDARY token family (label = -contrast, pressed = -shade)
     — role semantics: secondary = actions/attention (see src/theme/tokens.ts). */
  background-color: var(--app-color-secondary, #fecf48);
  color: var(--app-color-secondary-contrast, #041723);
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  padding: 0px 20px;
  line-height: 50px;
  font-size: 18px;
  display: flex;
  width: fit-content;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  position: relative;

  &:active {
    background-color: var(--app-color-secondary-shade, #e0b63f);
  }

  /* A 50px-tall pill with 18px bold text is right for a thumb on a 390px phone;
     on a laptop it reads as an oversized banner. Still well over the 44px touch
     target, and mobile is untouched. */
  @media (min-width: 768px) {
    line-height: 44px;
    font-size: 16px;
  }
`;

export default Button;
